import { cn } from '@/utils/utils.ts';
import { TDevice } from '@/features/devices/schemas/devices.schemas.ts';
import './device-card.css';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export const DeviceCard = ({ device }: { device: TDevice }) => {
  const { t } = useTranslation();
  return (
    <li key={device.deviceId} className="device-grid-item flex rounded-lg border bg-white">
      <div
        className={cn(
          'w-3 rounded-l-lg',
          device.type === 'Inverter' ? 'bg-[#5B657E]' : 'bg-[#C2B98B]'
        )}
      ></div>
      <div className="p-3">
        <div className="flex items-center gap-2">
          <Link to={device.deviceId}>
            <h3 className="text-lg font-semibold">{device.name}</h3>
          </Link>
          {/* <div
            className={cn(
              'status flex justify-center items-center rounded-lg',
              device.status === 'Offline'
                ? 'bg-[#C4C4C4]'
                : device.status === 'MaintenancePage'
                ? 'bg-[#9333ea]'
                : device.status === 'Critical'
                ? 'bg-[#e11d48]'
                : 'bg-[#087E53]'
            )}
          >
            <span className="text-xs text-white">{device.status}</span>
          </div> */}
        </div>
        <div className="flex w-full justify-between">
          <div className="grid max-w-[400px] grid-cols-2 gap-x-4 gap-y-4 text-sm">
            <div className="flex flex-col border-l-2 py-1 pl-2">
              <span className="text-[#7D7D85]">{t('devices.details.deviceType.title')}</span>
              <div className="flex gap-1 font-medium">
                <span>{device.type}</span>
              </div>
            </div>
            {/* <div className="flex flex-col py-1 pl-2 border-l-2">
              <span className="text-[#7D7D85]">Plant Name</span>
              <div className="flex gap-1 font-medium">
                <span>{device.}</span>
              </div>
            </div> */}
            <div className="flex flex-col border-l-2 py-1 pl-2">
              <span className="text-[#7D7D85]">{t('devices.details.model')}</span>
              <div className="flex gap-1 font-medium">
                <span>{device.sn ?? '-'}</span>
              </div>
            </div>
            <div className="flex flex-col border-l-2 py-1 pl-2">
              <span className="text-[#7D7D85]">{t('devices.details.supplier')}</span>
              <div className="flex gap-1 font-medium">
                <span>{device.supplier}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};
